import services from 'services';
import {describeThrow} from 'utils/errors';
import msgs from 'dicts/messages';

let httpJson = null;
services.waitFor('api').then(x => (httpJson = x.httpJson));
let intl = null;
services.waitFor('intl').then(x => (intl = x));

export const getLists = (params = {}) =>
	httpJson('get', `/lists`, params)
		.catch(describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})))
		.then(res => res.data);

export const getList = (id, params = {}) =>
	httpJson('get', `/lists/${id}`, params)
		.catch(describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})))
		.then(res => res.data);

export const createList = list =>
	httpJson('post', `/lists`, {}, {body: list}).catch(
		describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})),
	);

export const updateList = (id, body) =>
	httpJson('put', `/lists/${id}`, {}, {body}).catch(
		describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})),
	);

export const deleteList = id =>
	httpJson('delete', `/lists/${id}`).catch(
		describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})),
	);

/**
 * Attaches multiple items to a list with optional comments.
 *
 * @param {Object} body - The payload containing data for the mass attach operation.
 * @param {string|number} body.listId - The ID of the list to attach items to.
 * @param {Array} body.items - The items to attach to the list.
 * @param {string} [body.comments] - Optional comments to associate with the attached items.
 * @returns {Promise<Object>} A promise that resolves with the server response or rejects with a formatted error.
 */
export const massAttachToList = body =>
	httpJson('post', `/listItems/massAttach`, {}, {body}).catch(
		describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})),
	);

export const massDetachFromList = (listId, items) =>
	httpJson('post', `/listItems/massDetach`, {}, {body: {listId, items}}).catch(
		describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})),
	);

export const updateListItem = (id, body) =>
	httpJson('put', `/listItems/${id}`, {}, {body}).catch(
		describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})),
	);

export const getListItems = (params = {}) =>
	httpJson('get', `/listItems`, params).catch(
		describeThrow(intl.formatMessage({id: msgs.contentFetchFailed})),
	);
